import React, { useState } from "react";
import { Card, Headline, Button, Radio, Paragraph } from "_styleguide";
import { useSettings } from "_contexts/useSettings";
import { useApolloClient } from "@apollo/client";
import { userVerifySSN } from "_graphql/mutations";
import { message } from "@centrate-io/barn";
import { isDarkColor } from "_helpers/colors";
import "./VerifySSN.scss";

function VerifySSN(props) {
  const client = useApolloClient();
  const [value, setValue] = useState();
  const onChange = (e) => {
    setValue(e.target.value);
  };
  const { settings } = useSettings();
  const pageSettings = props.pageSettings;

  const clickVerify = async () => {
    props.setLoadingReport(true);
    const stateResponse = await client.mutate({
      variables: {
        application_id: props?.lead?.id,
        ssn: value,
      },
      mutation: userVerifySSN,
    });
    if (stateResponse?.data?.userVerifySSN === "success") {
      await props.checkState();
    } else {
      props.setLoadingReport(false);
      message.error("Invalid selection, please contact us");
    }
  };

  const primaryColor = settings?.primary_color || "#0f766e";
  const primaryFontColor = isDarkColor(primaryColor) ? "#fff" : "#000";

  return (
    <div id="verify-ssn">
      <Card>
        <div>
          <Headline>
            {pageSettings?.verify_title ||
              "Select the last 4 digits of your social security number:"}
          </Headline>
          <Paragraph
            opacity={0.6}
            align="left"
            dangerouslySetInnerHTML={{
              __html:
                pageSettings?.verify_subtitle ||
                "We need to confirm your identity. It's safe, secure & won't affect your credit score.",
            }}
          />
          <Radio.Group
            style={{
              "--radio-color": primaryColor,
              "--radio-text-color": settings?.secondary_color || "#000",
              "--radio-font-color": primaryFontColor,
            }}
            onChange={onChange}
            value={value}
            options={props.ssns?.map((s, i) => ({
              value: s,
              label: `XXX - XX - ${s}`,
            }))}
          />
        </div>
      </Card>
      <div className="credit-report-actions">
        <Button
          block
          size="large"
          style={{ background: primaryColor, color: primaryFontColor }}
          onClick={clickVerify}
          disabled={!value}
          loading={props.loadingReport}
        >
          Next Step
        </Button>
      </div>
    </div>
  );
}

export default VerifySSN;
